export const SGP_BANK_LIST = [
  'Deutsche Bank',
  'ANZ Bank',
  'BANGKOK BANK PUBLIC COMPANY LIMITED',
  'BANK OF AMERICA, NATIONAL ASSOCIATION',
  'Bank of China',
  'BANK OF EAST ASIA LTD',
  'BANK OF INDIA',
  'Bank of Singapore',
  'BNP Paribas',
  'CHINATRUST COMMERCIAL BANK CO LTD',
  'CIMB Bank',
  'Citibank',
  'COMMERZBANK AKTIENGESELLSCHAFT',
  'CreDIT?AGRICOLE CORPORATE AND INVESTMENT BANK',
  'DBS Bank',
  'DnB?BANK ASA',
  'Far Eastern Bank',
  'FIRST COMMERCIAL BANK',
  'HL Bank',
  'HSBC Bank',
  'INDIAN BANK',
  'INDIAN OVERSEAS BANK',
  'INTESA SANPAOLO S.p.A.',
  'KOREA EXCHANGE BANK',
  'Malayan Banking (Maybank)',
  'Mizuho Bank',
  'NATIONAL AUSTRALIA BANK LTD',
  'NORDEA BANK FINLAND PLC',
  'OCBC Bank',
  'POSB Bank',
  'PT BANK NEGARA INDONESIA (PERSERO) TBK',
  'Qatar National Bank SAQ',
  'RHB Bank',
  'SKANDINAVISKA ENSKILDA BANKEN AB',
  'SOCIETE GENERALE',
  'Standard Chartered Bank',
  'State Bank of India',
  'Sumitomo Mitsui Banking Corporation',
  'SVENSKA HANDELSBANKEN AB',
  'The Bank of Tokyo-Mitsubishi UFJ',
  'UBS AG',
  'UCO BANK',
  'UOB BANK',
];
